// @ts-nocheck
// ====== Filtri salvati ("Le mie viste") ======
// Salva in localStorage per-utente le combinazioni di filtri della vista Clienti
// che l'utente usa di frequente, e le rende richiamabili con un click.
//
// Chiave localStorage: `mase.savedViews.<email>` -> array di { id, name, filters }.
// `filters` contiene i value attuali dei controlli #globalSearch, #filterPM,
// #filterAmbiente, #filterRisorsa, #filterStato.

const FIELDS = ['clientiSearch', 'filterPM', 'filterAmbiente', 'filterRisorsa', 'filterStato'];

// F7: preset direzionali predefiniti (oversight provisioning). Non eliminabili.
const PRESET_VIEWS = [
  { id: 'preset-darichiedere', name: 'Da richiedere', filters: { filterStato: 'Da richiedere' } },
  { id: 'preset-richieste', name: 'In attesa', filters: { filterStato: 'Richieste' } },
  { id: 'preset-daeliminare', name: 'Da eliminare', filters: { filterStato: 'Da eliminare' } }
];

function storageKey() {
  const u = typeof getCurrentUser === 'function' ? getCurrentUser() : null;
  const id = (u && (u.email || u.name)) || 'anon';
  return 'mase.savedViews.' + id;
}

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(storageKey()) || '[]');
  } catch (_) {
    return [];
  }
}

function writeAll(arr) {
  localStorage.setItem(storageKey(), JSON.stringify(arr || []));
}

function captureFilters() {
  const out = {};
  FIELDS.forEach((id) => {
    const el = document.getElementById(id);
    if (el) out[id] = el.value || '';
  });
  return out;
}

function applyFilters(filters) {
  FIELDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.value = filters?.[id] ?? '';
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function hasAnyFilter(f) {
  return FIELDS.some((k) => (f[k] || '').trim());
}

function summarize(f) {
  const parts = [];
  if (f.clientiSearch) parts.push('"' + f.clientiSearch + '"');
  if (f.filterPM) parts.push('CPL ' + f.filterPM);
  if (f.filterAmbiente) parts.push(f.filterAmbiente);
  if (f.filterRisorsa) parts.push('R: ' + f.filterRisorsa);
  if (f.filterStato) parts.push(f.filterStato);
  return parts.join(' · ') || 'nessun filtro';
}

function renderSavedViews() {
  const root = document.getElementById('savedViewsBar');
  if (!root) return;
  const all = readAll();
  if (!all.length) {
    root.innerHTML = '<span class="muted" style="font-size:11px;">Nessuna vista salvata</span>';
    return;
  }
  root.innerHTML = all
    .map(
      (v) => `
      <span class="saved-view-chip" data-vid="${escapeHtml(v.id)}" title="${escapeHtml(summarize(v.filters))}">
        <button type="button" class="saved-view-apply" data-apply="${escapeHtml(v.id)}">${escapeHtml(v.name)}</button>
        <button type="button" class="saved-view-del" data-del="${escapeHtml(v.id)}" title="Rimuovi vista" aria-label="Rimuovi vista">✕</button>
      </span>`
    )
    .join('');
  root.querySelectorAll('[data-apply]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const v = readAll().find((x) => x.id === btn.dataset.apply);
      if (!v) return;
      applyFilters(v.filters);
      toast('Vista "' + v.name + '" applicata');
    });
  });
  root.querySelectorAll('[data-del]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const v = readAll().find((x) => x.id === btn.dataset.del);
      if (!v) return;
      const ok =
        typeof confirmAction === 'function'
          ? await confirmAction({
              level: 'info',
              title: 'Rimuovere vista salvata',
              message: 'Vuoi rimuovere la vista "' + v.name + '"?',
              confirmText: 'Rimuovi'
            })
          : confirm('Rimuovere "' + v.name + '"?');
      if (!ok) return;
      writeAll(readAll().filter((x) => x.id !== v.id));
      renderSavedViews();
    });
  });
}

function renderPresetViews() {
  const root = document.getElementById('presetViewsBar');
  if (!root) return;
  root.innerHTML = PRESET_VIEWS.map(
    (v) => `
      <button type="button" class="saved-view-apply preset-chip" data-preset="${escapeHtml(v.id)}" title="${escapeHtml(summarize(v.filters))}">${escapeHtml(v.name)}</button>`
  ).join('');
  root.querySelectorAll('[data-preset]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const v = PRESET_VIEWS.find((x) => x.id === btn.dataset.preset);
      if (!v) return;
      applyFilters(v.filters);
      toast('Preset "' + v.name + '" applicato');
    });
  });
}

async function saveCurrentView() {
  const filters = captureFilters();
  if (!hasAnyFilter(filters)) {
    toast('Imposta almeno un filtro prima di salvare la vista');
    return;
  }
  const name = (window.prompt('Nome della vista (es. "Azure da richiedere")') || '').trim();
  if (!name) return;
  const all = readAll();
  all.push({ id: 'v' + Date.now().toString(36), name, filters });
  writeAll(all);
  renderSavedViews();
  toast('Vista salvata');
}

function mountSavedViewsBar() {
  const filters = document.querySelector('#view-clienti .filters');
  if (!filters || document.getElementById('savedViewsBar')) return;
  // inserisci un container subito sotto la barra filtri
  const row = document.createElement('div');
  row.className = 'saved-views-row';
  row.innerHTML = `
    <button type="button" class="btn btn-sm" id="btnSaveCurrentView" title="Salva i filtri correnti come vista riusabile">
      <svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
        <polyline points="17 21 17 13 7 13 7 21"/>
        <polyline points="7 3 7 8 15 8"/>
      </svg>
      Salva vista
    </button>
    <span class="saved-views-label muted">Preset:</span>
    <span id="presetViewsBar" class="saved-views-bar"></span>
    <span class="saved-views-label muted">Le mie viste:</span>
    <span id="savedViewsBar" class="saved-views-bar"></span>
  `;
  filters.insertAdjacentElement('afterend', row);
  document.getElementById('btnSaveCurrentView').addEventListener('click', saveCurrentView);
  renderPresetViews();
  renderSavedViews();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountSavedViewsBar);
} else {
  mountSavedViewsBar();
}
// La vista "clienti" è lazy: rimonta la barra viste salvate dopo l'iniezione.
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') mountSavedViewsBar();
});

Object.assign(globalThis, {
  renderSavedViews,
  renderPresetViews,
  saveCurrentView,
  mountSavedViewsBar
});
export {};
